const EVENTS_CUSTOM_DOM = {
  OAUTH_COMPLETE: "oauthComplete",
  GOOGLE_ONE_TAP_LOAD: "googleOneTapLoadEvent",
};
export default EVENTS_CUSTOM_DOM;
